import { SiteUrls } from '@tableau/shared-urls';
import { RestApiServiceParams } from '@tableau/vizportalclient-common-components';
import { QueryClient } from '@tanstack/query-core';
import React from 'react';
import { FeatureFlags } from '../../featureFlags/FeatureFlags';
import { TelemetryContext } from '../../telemetry/TelemetryContext';

export type ContextOverrides = Partial<{
  readonly telemetryContext: TelemetryContext;
  readonly restApiServiceParams: RestApiServiceParams;
  readonly queryClient: QueryClient;
  readonly siteUrls: SiteUrls;
  readonly featureFlags: FeatureFlags;
}>

export function useContextWithOverride<T>(context: React.Context<T>, override?: T): T {
  const value = React.useContext(context);
  const result = override ?? value;
  return result;
}
